import Caption from './Caption';
import Heading from './Heading';
import Link from './Link';
import Note from './Note';
import Paragraph from './Paragraph';
import SubTitle from './SubTitle';
import Text from './Text';
import Tiny from './Tiny';
import Title from './Title';
import OriginTypography from './Typography';
const Typography = OriginTypography;
Typography.Text = Text;
Typography.Link = Link;
Typography.Heading = Heading;
Typography.Title = Title;
Typography.SubTitle = SubTitle;
Typography.Caption = Caption;
Typography.Note = Note;
Typography.Paragraph = Paragraph;
Typography.Tiny = Tiny;
export default Typography;
